import {apiGet, apiPost, apiPut} from './client'

/* Заметка в Gramps — отдельный объект: у персоны лежит только список
 * handle в note_list. Текст внутри — {text: {string: "..."}}. */

export interface NoteRaw {
  handle: string
  gramps_id?: string
  type?: string | {string?: string}
  text?: {string?: string}
  [k: string]: unknown
}

export const noteText = (n: NoteRaw | undefined): string => n?.text?.string || ''

export const noteType = (n: NoteRaw | undefined): string =>
  typeof n?.type === 'string' ? n.type : n?.type?.string || ''

/** Типы заметок, которые реально встречаются в дереве после импорта. */
const NOTE_RU: Record<string, string> = {
  'Person Note': '', // подпись не нужна: это заметка о человеке и так
  'GEDCOM import': 'из импорта',
  'Media Note': 'о снимке',
  'Source Note': 'об источнике',
  General: '',
}

export const noteLabel = (n: NoteRaw | undefined): string => {
  const t = noteType(n)
  return t in NOTE_RU ? NOTE_RU[t] : t
}

export const loadNotes = (handles: string[]): Promise<NoteRaw[]> =>
  Promise.all(handles.map(h => apiGet<NoteRaw>(`/notes/${h}`)))

/** Создаёт заметку и возвращает handle. Номер назначает сервер. */
export async function createNote(text: string): Promise<string> {
  const res = await apiPost<{handle?: string; _class?: string}[]>('/notes/', {
    _class: 'Note',
    text: {_class: 'StyledText', string: text, tags: []},
    // 4 = Person Note: именно такой тип ставит и сам Gramps,
    // когда заметку заводят из карточки человека
    type: {_class: 'NoteType', value: 4, string: ''},
    format: 0,
    private: false,
    tag_list: [],
  })
  const h = (res || []).find(i => i._class === 'Note')?.handle || res?.[0]?.handle
  if (!h) throw new Error('Сервер не вернул идентификатор заметки')
  return h
}

export async function updateNote(handle: string, text: string): Promise<void> {
  const full = await apiGet<NoteRaw>(`/notes/${handle}`)
  await apiPut(`/notes/${handle}`, {
    ...full,
    text: {...(full.text || {}), _class: 'StyledText', string: text},
  })
}
